export const styles = ({
    content: {
        display: 'flex',
        justifyContent: 'center'
    }
});
